import { render, staticRenderFns } from "./FlipClock.vue?vue&type=template&id=5d472996&"
import script from "./FlipClock.vue?vue&type=script&lang=js&"
export * from "./FlipClock.vue?vue&type=script&lang=js&"
import style0 from "./FlipClock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports